import { Toaster, TooltipProvider } from '@reelplicate/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { type ReactNode, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { ErrorFallback } from '@/components/error-fallback';

import { createQueryClient } from './query-client';

/**
 * App-wide providers. The outer ErrorBoundary is the last line of defence -
 * route and feature boundaries catch almost everything before it.
 */
export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {/* No theme provider: Figma has one (light) theme, `dark:` only applies
          under a `.dark` class nothing sets, and the Toaster is fixed to light. */}
      <QueryClientProvider client={queryClient}>
        {/* One provider for every Tooltip: shared open/close delays. */}
        <TooltipProvider>
          {children}
          <Toaster />
        </TooltipProvider>
        <ReactQueryDevtools buttonPosition="bottom-left" />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
